import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import PropostasDetails from './details';
import { useContext } from '@components';
import CrmPropostasListView from './list';
export default angular
    .module('app.crm.propostas', [])
    .config(routes)
    .component('crmPropostasDetailsView', react2angular(useContext.use(PropostasDetails), [], ['$state', 'CrmService']))
    .component('crmPropostasListView', react2angular(useContext.use(CrmPropostasListView), [], ['$state', 'CrmService', "UIService"]))
    .name;
